import { Result } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const NotFound = () => {
  const { language, englishLang } = useSelector((store) => ({
    language: store.langReducer.language,
    englishLang: store.langReducer.englishLang,
  }));
  return (
    <Result
      status="404"
      title="404"
      subTitle={
        language?.PAGE_DOSENT_EXIST?.value ??
        englishLang?.PAGE_DOSENT_EXIST?.value
      }
      // extra={<Button type="primary">Back Home</Button>}
    />
  );
};

export default NotFound;
